import { STATUSES } from 'modules/Finance/PromisedPayment/config/consts'
import styles from 'modules/Finance/PromisedPayment/PromisedPayment.module.scss'

export default () => ({
  initial: {
    statuses: [],
    wallets: [],
  },
  configuration: {
    statuses: {
      order: 1,
      subbutton: {
        isVisible: false,
      },

      label: 'promised_payment::filters.dropdown.items.statuses.label',
      type: 'checkbox selector',
      typeAsButtonControl: 'checkbox selector',
      optionLabelPrefix: 'promised_payment::filters.dropdown.items.statuses.options.',
      className: styles['promised-payment__filter-panel-statuses'],
      options: Object.keys(STATUSES).filter((key) => key !== 'expired'),
    },
    wallets: {
      order: 2,
      subbutton: {
        isVisible: false,
      },

      label: 'promised_payment::filters.dropdown.items.wallets.label',
      type: 'checkbox selector',
      typeAsButtonControl: 'checkbox selector',
      className: styles['promised-payment__filter-panel-wallets'],
      options: [],
    },
  },
})
